import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { formatData } from 'components/helpers/reactQuery';

export function useUsersQuery({ params }) {
  return useQuery({
    queryKey: ['users', params],
    queryFn: async () => {
      const response = await axios.get('/users', {
        params,
        paramsSerializer: (requestParams) =>
          qs.stringify(requestParams, { arrayFormat: 'brackets' }),
      });

      return response.data;
    },
    select: (data) =>
      formatData({
        data,
        resourceTypes: ['company', 'accessControl', 'profilePhoto'],
      }),
    keepPreviousData: true,
  });
}
